// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Nurse from '@/components/pages/Nurses/Nurse.vue'
import EditNurse from '@/components/pages/Nurses/EditNurse.vue'

export default {
  path: '/nurses',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      redirect: '/users'
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Nurse,
          props: true,
          name: 'view-nurse'
        },
        {
          path: 'edit',
          component: EditNurse,
          name: 'edit-nurse',
          props: true,
          meta: {breadcrumb: 'Edit'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/nurses.js